import React, { FC } from "react";
import EPGAdminLayout from "../../../layouts/admin/EPGAdminLayout";

const EPGAdminHomeView: FC = () => {
    return (
        <>
            <EPGAdminLayout heading="EPG">
                <div className="h-full flex flex-col mr-6">
                </div>
            </EPGAdminLayout>
        </>
);
};

export default EPGAdminHomeView;